import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../hooks/useCart';
import { useTelegram } from '../hooks/useTelegram';
import { CartItem } from '../components/CartItem';
import { Loading } from '../components/Loading';
import './CartPage.css';

export const CartPage: React.FC = () => {
  const navigate = useNavigate();
  const { cart, loading, error, fetchCart, updateCartItem, removeFromCart } = useCart();
  const { tg } = useTelegram();

   
   
  useEffect(() => {
    fetchCart();

    // Show back button
    if (tg?.BackButton) {
      tg.BackButton.show();
      tg.BackButton.onClick(handleBack);
    }

    return () => {
      if (tg?.BackButton) {
        tg.BackButton.hide();
        tg.BackButton.offClick(handleBack);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tg]);


  const handleBack = () => {
    navigate('/');
  };

  const handleUpdateQuantity = async (itemId: number, quantity: number) => {
    const success = await updateCartItem(itemId, quantity);

    if (success) {
      if (tg?.HapticFeedback) {
        tg.HapticFeedback.selectionChanged();
      }
    } else {
      if (tg?.HapticFeedback) {
        tg.HapticFeedback.notificationOccurred('error');
      }
    }
  };

  const handleRemove = async (itemId: number) => {
    const success = await removeFromCart(itemId);

    if (success) {
      if (tg?.HapticFeedback) {
        tg.HapticFeedback.notificationOccurred('success');
      }
    } else {
      if (tg?.HapticFeedback) {
        tg.HapticFeedback.notificationOccurred('error');
      }
    }
  };

  const handleProductClick = (productId: number) => {
    navigate(`/product/${productId}`);
  };

  const handleCheckout = () => {
    if (tg?.HapticFeedback) {
      tg.HapticFeedback.impactOccurred('light');
    }
    navigate('/checkout');
  };

  const formatPrice = (price: number) => {
    return `${price.toFixed(0)} ₽`;
  };

  if (loading && !cart) {
    return (
      <div className="page cart-page">
        <div className="cart-header">
          <button className="back-btn" onClick={handleBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="cart-title">Корзина</h1>
        </div>
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="page cart-page">
        <div className="cart-header">
          <button className="back-btn" onClick={handleBack}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <h1 className="cart-title">Корзина</h1>
        </div>
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button className="retry-button" onClick={() => fetchCart()}>
            Попробовать снова
          </button>
        </div>
      </div>
    );
  }

  const isEmpty = !cart || !cart.items || cart.items.length === 0;

  return (
    <div className="page cart-page">
      <div className="cart-header">
        <button className="back-btn" onClick={handleBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="cart-title">Корзина</h1>
      </div>

      {isEmpty ? (
        <div className="empty-cart">
          <div className="empty-cart-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
              <path d="M20 20L16.67 60C16.67 61.7681 17.3725 63.4638 18.6228 64.7141C19.873 65.9643 21.5688 66.6667 23.3369 66.6667H56.6631C58.4312 66.6667 60.127 65.9643 61.3772 64.7141C62.6275 63.4638 63.33 61.7681 63.33 60L60 20M13.3333 20H66.6667M26.6667 20V13.3333C26.6667 11.5652 27.3691 9.86953 28.6193 8.61929C29.8696 7.36905 31.5652 6.66667 33.3333 6.66667H46.6667C48.4348 6.66667 50.1304 7.36905 51.3807 8.61929C52.6309 9.86953 53.3333 11.5652 53.3333 13.3333V20" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="empty-cart-title">Корзина пуста</h2>
          <p className="empty-cart-text">Добавьте товары из каталога</p>
          <button className="back-to-catalog-btn" onClick={handleBack}>
            Перейти в каталог
          </button>
        </div>
      ) : (
        <>
          <div className="cart-content">
            <div className="cart-items">
              {cart.items.map((item) => (
                <CartItem
                  key={item.id}
                  item={item}
                  onUpdateQuantity={handleUpdateQuantity}
                  onRemove={handleRemove}
                  onProductClick={handleProductClick}
                />
              ))}
            </div>
          </div>

          <div className="cart-footer">
            <div className="cart-summary">
              <div className="summary-row">
                <span className="summary-label">Товары ({cart.items.length}):</span>
                <span className="summary-value">{formatPrice(cart.total_amount - cart.delivery_fee)}</span>
              </div>
              {cart.delivery_fee > 0 && (
                <div className="summary-row">
                  <span className="summary-label">Доставка:</span>
                  <span className="summary-value">{formatPrice(cart.delivery_fee)}</span>
                </div>
              )}
              {cart.delivery_fee > 0 && (
                <div className="delivery-notice">
                  Бесплатная доставка при заказе от 5000 ₽
                </div>
              )}
              <div className="summary-row summary-total">
                <span className="summary-label">Итого:</span>
                <span className="summary-value">
                  {formatPrice(cart.total_amount)}
                </span>
              </div>
            </div>

            <button className="checkout-btn" onClick={handleCheckout}>
              Перейти к оформлению
            </button>
          </div>
        </>
      )}
    </div>
  );
};
